var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c(
        "q-card",
        [
          _c("q-card-main", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-8 col-xs-6" },
                [
                  _c("g-input", {
                    ref: "refCodigo",
                    attrs: {
                      id: "refCodigo",
                      name: "refCodigo",
                      tipo: "text",
                      etiqueta: "Código",
                      validacao: "numeric",
                      desabilitar: true,
                      foco: false
                    },
                    model: {
                      value: _vm.paginaStatus.assunto.codAssunto,
                      callback: function($$v) {
                        _vm.$set(_vm.paginaStatus.assunto, "codAssunto", $$v)
                      },
                      expression: "paginaStatus.assunto.codAssunto"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12 col-xs-12" },
                [
                  _c("g-input", {
                    ref: "refDescricao",
                    attrs: {
                      id: "refDescricao",
                      name: "refDescricao",
                      tipo: "text",
                      etiqueta: "Descrição",
                      validacao: "required | maxlength(100)",
                      tamanho: 100,
                      foco: false,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.paginaStatus.assunto.desAssunto,
                      callback: function($$v) {
                        _vm.$set(_vm.paginaStatus.assunto, "desAssunto", $$v)
                      },
                      expression: "paginaStatus.assunto.desAssunto"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-5 col-md-5" },
                [
                  _c("g-option", {
                    ref: "refAtivo",
                    attrs: {
                      id: "ativo",
                      name: "ativo",
                      tipo: "radio",
                      option: _vm.arrayAtivoEnum,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao,
                      etiqueta: "Ativo",
                      validacao: "required"
                    },
                    model: {
                      value: _vm.indAtivo,
                      callback: function($$v) {
                        _vm.indAtivo = $$v
                      },
                      expression: "indAtivo"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-5 col-md-5" },
                [
                  _c("g-option", {
                    ref: "toogleVisivelPortal",
                    attrs: {
                      id: "toogleVisivelPortal",
                      name: "toogleVisivelPortal",
                      tipo: "radio",
                      option: _vm.arrayAtivoEnum,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao,
                      etiqueta: "Visível no portal de serviços.",
                      validacao: "required"
                    },
                    model: {
                      value: _vm.indVisivelPortal,
                      callback: function($$v) {
                        _vm.indVisivelPortal = $$v
                      },
                      expression: "indVisivelPortal"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 text-right pad-20t-h10-80b" },
        [
          _c(
            "q-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.paginaStatus.desabilitarEdicao,
                  expression: "!paginaStatus.desabilitarEdicao"
                }
              ],
              staticClass: "fixed",
              staticStyle: { right: "18px", bottom: "18px" },
              attrs: {
                round: "",
                id: "salvar",
                name: "salvar",
                color: "positive",
                icon: "check",
                size: "lg"
              },
              on: { click: _vm.salvar }
            },
            [_c("q-tooltip", [_vm._v("Salvar")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }